import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'templates'
const verb = HttpMethod.POST

export default class OspreyTemplatesShareToSilos extends BaseAction {
    constructor(dataKey) {
        const id = '27e533d1-bd4a-464e-a1b7-af630bd37644'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToSilos(params) {
        const { templateId, siloIdList } = params

        this.path = `/${resource}/${templateId}/share/silos`

        this.params = {
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-silos-share.js